import { api } from 'shared';
import { z } from 'zod';

const DeliveryArticlesByUidsResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            price: z.number().optional().nullable(),
            images: z.array(
                z.object({
                    url: z.string(),
                }),
            ).optional().nullable(),
            currency: z.object({
                name: z.string(),
                abbreviation: z.string(),
            }).optional().nullable(),
        }),
    ),
});

export const fetchDeliveryArticlesByUids = async (uids: string[]) => (
    api.get<z.infer<typeof DeliveryArticlesByUidsResponseSchema>>(
        '/delivery-articles',
        {
            filters: {
                slug: {
                    $in: uids,
                },
            },
            populate: {
                images: {
                    fields: '*',
                },
                currency: {
                    fields: '*',
                },
            },
        },
        DeliveryArticlesByUidsResponseSchema,
    )
);
